import { render, staticRenderFns } from "./UserEmailLog.vue?vue&type=template&id=28e0ab4f"
import script from "./UserEmailLog.vue?vue&type=script&lang=js"
export * from "./UserEmailLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports